export const EVENT_TYPES = {
  FORM_SUBMIT: 'form_submit',
  SPAM_SUBMISSION: 'spam_submission',
  PROMO_IMPRESSION: 'promo_impression',
  PROMO_LP_VISIT: 'promo_lp_visit',
  PROMO_CLICK: 'promo_click',
  PROMO_VDP_VISIT: 'promo_vdp_visit',
  PROMO_CONVERSION: 'promo_conversion',
  PAGE_VIEW: 'page_view',
  USER_ENGAGEMENT: 'user_engagement',
};

export const EVENT_FIELDS = {
  DEPARTMENT: 'department',
  PAGE_URI: 'page_uri',
  PAGE_TYPE: 'page_type',
  VEHICLE_GROUP: 'group',
  VEHICLE_TYPE: 'vehicle_type',
  VEHICLE_MAKE: 'make',
  VEHICLE_MODEL: 'model',
  VEHICLE_SUBMODEL: 'submodel',
  VEHICLE_YEAR: 'year',
  VEHICLE_CONDITION: 'condition',
  VEHICLE_LOCATION: 'gd_location',
  VEHICLE_STOCKID: 'stock_id',
  LEAD_ENTRY_POINT: 'lead_entry_point',
  LEAD_ID: 'lead_id',
  PROMOTION_ID: 'promotion_id',
  PROMOTION_NAME: 'promotion_name',
  AD_SIZE: 'ad_size',
  CLICK_CATEGORY: 'click_category',
  BUTTON_TITLE: 'button_title',
};
